"use client";

import { COMPANY_ADDRESS } from "@/lib/company";

import { trackPublicEvent } from "@/lib/public-analytics";

export default function Footer() {
  return (
    <footer className="mx-auto max-w-7xl px-6 pb-10">
      <div className="rounded-[2rem] border border-[#d7e5df] bg-white p-8">
        <div className="grid gap-6 border-b border-[#e4eeea] pb-8 md:grid-cols-4">
          <div>
            <p className="text-sm font-light text-[#007c7a]">
              Built with Gemini
            </p>
            <p className="mt-2 text-sm leading-6 text-[#52635f]">
              AI-powered scans, actions and weekly growth intelligence.
            </p>
          </div>

          <div>
            <p className="text-sm font-light text-[#007c7a]">On Google Cloud</p>
            <p className="mt-2 text-sm leading-6 text-[#52635f]">
              Built for secure, scalable small-business workspaces.
            </p>
          </div>

          <div>
            <p className="text-sm font-light text-[#007c7a]">
              Payments by Stripe
            </p>
            <p className="mt-2 text-sm leading-6 text-[#52635f]">
              Subscriptions, scans and Task Credits will be processed securely.
            </p>
          </div>

          <div>
            <p className="text-sm font-light text-[#007c7a]">
              Made in Ireland, EU
            </p>
            <p className="mt-2 text-sm leading-6 text-[#52635f]">
              Built by Tao Climate in Dublin with privacy and trust at the
              centre.
            </p>
          </div>
        </div>

        <div className="grid gap-8 pt-8 md:grid-cols-[1.1fr_0.9fr]">
          <div>
            <h3 className="text-xl font-light">
              Your data stays private and secure.
            </h3>
            <p className="mt-3 text-sm leading-6 text-[#52635f]">
              MarginGlow does not learn who you work with. It learns what works.
              We use your documents and connected accounts to power your private
              workspace, and we learn from anonymised operational patterns and
              verified outcomes to improve revenue, cost and waste
              recommendations. We never share your raw documents, customer
              records, supplier details or private business information.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-5 text-sm font-light text-[#52635f] md:justify-end">
            <a
              href="/small-business-101"
              onClick={() =>
                trackPublicEvent("small_business_101_nav_click", {
                  link_location: "footer",
                })
              }
              className="text-[#007c7a]"
            >
              Small Business 101
            </a>

            <a
              href="/signal"
              onClick={() =>
                trackPublicEvent("signal_footer_click", {
                  product: "marginglow_ai_signal",
                  audience: "human",
                  link_location: "footer",
                })
              }
              className="text-[#007c7a]"
            >
              MarginGlow AI Signal
            </a>
            <a href="https://the-way-newsletter.garybyrnes.chatgpt.site/">Newsletter</a>
            <a href="https://market.taoclimate.com">Tao Merch</a>
            <a href="/pricing">Pricing</a>
            <a href="/about">About</a>
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="/gdpr">GDPR and Data Rights</a>
            <a href="/impressum">Impressum</a>
            <a href="/ai-transparency">AI Transparency Policy</a>
            <button
              type="button"
              onClick={() =>
                window.dispatchEvent(
                  new Event("marginglow-open-privacy-settings"),
                )
              }
              className="text-left"
            >
              Privacy Settings
            </button>
            <div className="flex w-full flex-col items-start gap-6 md:flex-row md:items-center md:justify-end">
              <div className="flex flex-col justify-center gap-2">
                <a href="mailto:support@taoclimate.com">
                  Help and support: support@taoclimate.com
                </a>

                <a href="mailto:hello@taoclimate.com">
                  Partners and investors: hello@taoclimate.com
                </a>

                <address className="not-italic">Tao Climate Limited · {COMPANY_ADDRESS}, Ireland.</address>
                <p>
                  © Copyright Tao Climate Limited 2026, All Rights Reserved.
                </p>
              </div>

              <a
                href="https://www.taoclimate.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit Tao Climate"
                className="inline-flex shrink-0 self-center items-center md:self-auto"
              >
                <img
                  src="/brand-speed-v2/taoclimate-footer-logo.png"
                  alt="Tao Climate"
                  width="256"
                  height="123"
                  loading="lazy"
                  decoding="async"
                  className="h-auto w-32 object-contain"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
